import { ArrowUpRight, Mail, MapPin } from 'lucide-react'
import { Link } from 'react-router-dom'
import Logo from './Logo'

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__top">
        <div className="footer__lead">
          <span className="eyebrow">Ready to build real capability?</span>
          <h2>Let’s design a learning experience that moves people forward.</h2>
          <Link to="/contact" className="button">Start a conversation <ArrowUpRight size={18} /></Link>
        </div>
        <div className="footer__links">
          <div>
            <h3>Explore</h3>
            <Link to="/about">About us</Link><Link to="/programs">Learning pathways</Link>
            <Link to="/methodology">Methodology</Link><Link to="/corporate-training">Corporate training</Link>
          </div>
          <div>
            <h3>Connect</h3>
            <a href="mailto:hello@qubispark.com"><Mail size={15} /> hello@qubispark.com</a>
            <span><MapPin size={15} /> Canada · India · Online</span>
          </div>
        </div>
      </div>
      <div className="container footer__bottom">
        <Logo />
        <p>© {new Date().getFullYear()} Qubispark Technologies. All rights reserved.</p>
      </div>
    </footer>
  )
}
